import React, { Component } from "react";
import { withTranslation } from "react-i18next";

class Pricing extends Component {
  render() {
    const { t } = this.props;
    
    const priceContainerStyle = {
      padding: "0",
      marginBottom: "1.5rem"
    };
    
    const priceSubtitleStyle = {
      fontSize: "1rem",
      fontWeight: "600",
      marginBottom: "1rem",
      textTransform: "uppercase"
    };
    
    const menuItemStyle = {
      padding: "0.5rem 0",
      borderBottom: "1px dotted #ccc",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    };
    
    const itemNameStyle = {
      fontSize: "0.9rem",
      fontWeight: "500",
      margin: 0
    };
    
    const itemPriceStyle = {
      fontSize: "0.9rem",
      fontWeight: "600",
      margin: 0,
      minWidth: "50px",
      textAlign: "right"
    };
    
    return (
      
      <section className="services py-4">
        <div className="container py-3">
          <h3 className="heading text-capitalize text-center mb-4">
            {t("priceH.title")}
          </h3>
          <div className="row">
            <div className="col-md-6 mb-4 mb-md-0">
              <div style={priceContainerStyle}>
                <h5 style={priceSubtitleStyle}>{t("priceH.subtitle")}</h5>
                
                <div style={menuItemStyle}>
                  <h6 style={itemNameStyle}>{t("priceH.item_one")}</h6>
                  <h6 style={itemPriceStyle}>€25</h6>
                </div>
                
                <div style={menuItemStyle}>
                  <h6 style={itemNameStyle}>{t("priceH.item_two")}</h6>
                  <h6 style={itemPriceStyle}>€20</h6>
                </div>
              </div>
            </div>
            
            <div className="col-md-6">
              <div style={priceContainerStyle}>
                <h5 style={priceSubtitleStyle}>{t("priceH.subtittledisc")}</h5>
                
                <div style={menuItemStyle}>
                  <h6 style={itemNameStyle}>{t("priceH.item_three")}</h6>
                  <h6 style={itemPriceStyle}>€20</h6>
                </div>
                
                <div style={menuItemStyle}>
                  <h6 style={itemNameStyle}>{t("priceH.item_four")}</h6>
                  <h6 style={itemPriceStyle}>€23</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default withTranslation("global")(Pricing);
